import { Color } from 'modules/styles/colors';
import { RedirectBrand } from './types';

export interface RedirectProps {
  redirectBrand?: RedirectBrand;
}

export function getRegisterBrand(): RedirectBrand {
  return window?.sessionStorage?.getItem('registerBrand') || RedirectBrand.MHP;
}

export function getRedirectIdx(): string {
  return window?.sessionStorage?.getItem('redirectIdx');
}

export function getBrandColor(props: RedirectProps, usePrimary = false) {
  const { redirectBrand } = props;
  switch (redirectBrand) {
    case RedirectBrand.SH:
    case RedirectBrand.SC:
      return Color.magenta;
    default:
      return usePrimary ? Color.primary : Color.secondary;
  }
}

export function getBrandLinkColor(props: RedirectProps) {
  const { redirectBrand } = props;
  switch (redirectBrand) {
    case RedirectBrand.SH:
    case RedirectBrand.SC:
      return getBrandColor(props);
    default:
      return Color.link;
  }
}

export function getBrandHoverColor(props: RedirectProps) {
  const { redirectBrand } = props;
  switch (redirectBrand) {
    case RedirectBrand.SH:
    case RedirectBrand.SC:
      return Color.magentaHover;
    default:
      return Color.primaryHover;
  }
}

export function getBrandLightHoverColor(props: RedirectProps) {
  const { redirectBrand } = props;
  switch (redirectBrand) {
    case RedirectBrand.SH:
    case RedirectBrand.SC:
      return Color.magentaLightHover;
    default:
      return Color.outlinedPressed;
  }
}
